import { commonGetters, sortCompaniesInPrioritizedOrder } from '@/util/store-helpers';
import { router } from '@/router';

const common = commonGetters('companies', 'id');

// export const query = state => query => state.companies.filter(item => matchesQuery(item, query));
export const { query } = common;
export const { find } = common;
export const { get } = common;
export const { all } = common;
export const { loaded } = common;
export const { exists } = common;

export function findBySlug(state, getters) {
   return slug => getters.find({ slug });
}

export const priorityOrder = state => sortCompaniesInPrioritizedOrder(state.companies.slice());

export const list = state => state.companies;
// export const all = state => state.companies;
export const isFetching = state => state.fetching;
export const grouped = state => state.companies.reduce((result, company) => {
   if (company.active) {
      result.active.push(company);
   } else {
      result.inactive.push(company);
   }
   return result;
}, {
   active: [],
   inactive: [],
});
export const isUpdating = state => ({ slug }) => state.updating.indexOf(slug) !== -1;
export const arePrioritiesUpdating = state => ({ slug }) => state.priorities_updating.indexOf(slug) !== -1;
export const areCapacitiesUpdating = state => ({ slug }) => state.capacities_updating.indexOf(slug) !== -1;
// export const loaded = state => state.loaded;
// noinspection DuplicatedCode
export const blacklistedTrades = state => state.companies.reduce((result, company) => {
   for (const code of company.blacklisted_trades) {
      const intCode = parseInt(code, 10);
      if (typeof result[intCode] === 'undefined') {
         result[intCode] = [];
      }
      result[intCode].push(company);
   }
   return result;
}, {});

// noinspection DuplicatedCode
export const blacklistedZips = state => state.companies.reduce((result, company) => {
   for (const zip of company.blacklisted_zips) {
      const intCode = parseInt(zip, 10);
      if (typeof result[intCode] === 'undefined') {
         result[intCode] = [];
      }
      result[intCode].push(company);
   }
   return result;
}, {});

export const routeCompany = (state, getters) => {
   const route = router.currentRoute;
   if (!route || !route.params.slug) {
      return null;
   }
   return getters.findBySlug(route.params.slug);
};
